/** Load options for segment filters/dropdowns (full list for pickers, not the Segments tab table page). */
export const SEGMENT_DROPDOWN_PAGE_OPTIONS = {
    page: 0,
    size: 20,
    sort: "createdDate,desc",
};

export function getSegmentsTotalElements(raw) {
    if (typeof raw?.totalElements === "number") {
        return raw.totalElements;
    }
    if (typeof raw?.totalCount === "number") {
        return raw.totalCount;
    }
    if (Array.isArray(raw)) {
        return raw.length;
    }
    return normalizeSegmentsList(raw).length;
}

export function normalizeSegmentsList(raw) {
    if (Array.isArray(raw)) {
        return raw;
    }
    if (raw?.content && Array.isArray(raw.content)) {
        return raw.content;
    }
    if (raw?.segments && Array.isArray(raw.segments)) {
        return raw.segments;
    }
    if (raw?.id != null && (raw?.name != null || raw?.label != null)) {
        return [raw];
    }
    return [];
}

export function buildSegmentCountLookup(countPayload) {
    const lookup = new Map();
    if (countPayload == null) {
        return lookup;
    }

    if (Array.isArray(countPayload)) {
        countPayload.forEach((item) => {
            const id = item?.segmentId ?? item?.id;
            const count =
                item?.count ??
                item?.customerCount ??
                item?.businessCustomerCount ??
                item?.memberCount;
            if (id != null && count != null) {
                lookup.set(String(id), count);
            }
        });
        return lookup;
    }

    if (typeof countPayload === "object") {
        Object.entries(countPayload).forEach(([key, val]) => {
            if (typeof val === "number") {
                lookup.set(String(key), val);
                return;
            }
            if (val && typeof val === "object") {
                const id = val.segmentId ?? val.id ?? key;
                const count =
                    val.count ?? val.customerCount ?? val.businessCustomerCount ?? val.memberCount;
                if (id != null && count != null) {
                    lookup.set(String(id), count);
                }
            }
        });
    }

    return lookup;
}

export function getSegmentCustomerCount(segment, countLookup) {
    const direct =
        segment?.businessCustomerCount ??
        segment?.customerCount ??
        segment?.memberCount ??
        (typeof segment?.count === "number" ? segment.count : null);
    if (typeof direct === "number") {
        return direct;
    }
    if (segment?.id != null && countLookup?.has(String(segment.id))) {
        return countLookup.get(String(segment.id));
    }
    return null;
}

export function getSegmentDisplayName(segment) {
    return segment?.name ?? segment?.label ?? "";
}

export function getSegmentId(segment) {
    const id = segment?.id ?? segment?.segmentId;
    return id != null ? id : null;
}
